import { HTTPClient } from "./Client";

const EventoApi = {
    async criarEventoAsync(eventoCriar) {
        const response = await HTTPClient.post('/Evento/CriarEvento', eventoCriar);
        return response.data;
    },

    async atualizarEventoAsync(eventoAtualizar) {
        const response = await HTTPClient.put('/Evento/AtualizarEvento', eventoAtualizar);
        return response.data;
    },

    async obterEventoPorIdAsync(eventoId) {
        const response = await HTTPClient.get(`/Evento/ObterEventoPorId/${eventoId}`);
        return response.data;
    },

    async listarEventosAsync() {
        try {
            const response = await HTTPClient.get('/Evento/ListarEventos');
            return response.data;
        } catch (error) {
            console.error('Erro ao listar eventos:', error.response?.data || error.message);
            return []; // Retorna uma lista vazia em caso de erro
        }
    },

    async vincularEventoPessoasAsync(eventoPessoasVincular) {
        const response = await HTTPClient.post('/Evento/VincularEventoPessoas', eventoPessoasVincular);
        return response.data;
    },

    async vincularEventoTurmasAsync(eventoTurmasVincular) {
        const response = await HTTPClient.post('/Evento/VincularEventoTurmas', eventoTurmasVincular);
        return response.data;
    },

    async excluirEventoAsync(eventoId) {
        try {
            const response = await HTTPClient.delete(`/Evento/ExcluirEvento/${eventoId}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir evento:', error.response?.data || error.message);
            throw error; 
        }
    }
};

export default EventoApi;